import "./styles/corporate_register.scss";
import { AppContext } from '../../Context.tsx';
import { Typography } from "@mui/material";
import React, { useContext, useEffect, useRef } from "react";
import "./register.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import SelectInput from "../../components/TextInput/SelectInput";
import Button from "@mui/material/Button";
import BasicDatePicker from "../../components/DatePicker/BasicDatePicker";
import { useForm } from "react-hook-form";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor";
import axios from "axios";
import LandLinePhoneFormatter from "../../components/PhoneFormatter/LandLinePhoneFormatter";
import { MuiTelInput } from "mui-tel-input";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import { notification } from "antd";
import ApplicationFormController from "../Admin/Controller/application_form_controller.ts";
import DatabaseInterfaceController from '../../i-controllers/DatabaseInterfaceController.tsx';
import ICaptcha from '../../i-components/ICaptcha.tsx';
// import HCaptcha from '@hcaptcha/react-hcaptcha';

/** edited by delon 2025-05-30 */
import { useState, Fragment } from "react";
import { IonDate, IonDateString, IonDateFormat } from '../../i-components/IonDate.tsx';

const Register = () => {
  /** edited by delon on 2025-05-30 */
  //contexts
  const appContext = useContext(AppContext);
  //states
  const [popupMessage, SetPopupMessage] = useState("");
  const [popupAction, SetPopupAction] = useState(() => {});
  // const [hCaptchaToken, SetHCaptchaToken] = useState('');
  // const [hCaptchaVerified, SetHCaptchaVerified] = useState(false);
  const [captchaVerification, SetCaptchaVerification] = useState(null);
  //refs
  // const hCaptchaTokenRef = useRef('');
  //controllers
  const database = new DatabaseInterfaceController(appContext);

  //parameters declaration
  const key = "12345";
  /* key has no length limit, the longer the length more exhaustive encryption/decryption to process. Key shall not have 0, any 0's will be autoremoved */

  const mode = "YMDHI"; //optional parameter, default will be 'YMDHI'

  //initialize encyptor
  const Encryptor = new InfinityEncryptor(key, mode);
  const Encryptor2 = new InfinityEncryptor('22499', 'MYDIH'); //used by mobile_backend/scripts/mailControl

  //watchers
  //watch for hCaptchaToken updated, verifyHCaptcha
  // useEffect(() => {
  //   if(hCaptchaToken != hCaptchaTokenRef.current) {
  //     database.Queue('verifyHCaptcha', [
  //       ['verifyHCaptcha', 'true'],
  //       ['token', hCaptchaToken]
  //     ])
  //     hCaptchaTokenRef.current = hCaptchaToken;
  //   }
  // }, [hCaptchaToken]); ---deprecated

  //watch for databaseResultAction
  // useEffect(() => {
  //   if(appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction) {
  //     const ExecuteDatabaseResultAction = async() => {
  //       const [res, mode] = await appContext.databaseResultAction();

  //       switch(mode) {
  //           case 'verifyHCaptcha':
  //             if(!JSON.stringify(res).includes('_false')) {
  //               SetHCaptchaVerified(true);
  //             }
  //           break;
  //       }
  //     };

  //     switch(appContext.databaseActionModeQueue[0]) {
  //       case 'verifyHCaptcha':
  //         ExecuteDatabaseResultAction();
  //         break;
  //     }
  //   }
  // }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]); ---deprecated

  const required = () => (
    <span style={{ color: "red", marginLeft: "5px", fontSize: "17px" }}>*</span>
  );

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
    setError,
    getValues,
    clearErrors,
  } = useForm({
    defaultValues: {
      salutation: "",
      nameInFull: "",
      NRIC: "",
      DOB: "",
      registeredAddressStreet: "",
      registeredAddressState: "",
      registeredAddressCity: "",
      registeredAddressPostcode: "",
      correspondenceAddressStreet: "",
      correspondenceAddressState: "",
      correspondenceAddressCity: "",
      correspondenceAddressPostcode: "",
      placeOfEmployment: "",
      officeAddress: "",
      officeTelNo: "",
      HPNo: "",
      email: "",
      designation: "",
      natureOfWork: "",
      noOfYearsWithPresentEmployer: "",
      previousEmploymentPeriod_1: "",
      previousEmploymentDesignation_1: "",
      previousEmploymentPeriod_2: "",
      previousEmploymentDesignation_2: "",
      academicQualification: "",
      otheracademicQualification: "",
      tertiaryProfessional: "",
      IndividualMembershipCategory: "",
      eInvoiceNumber: "",
    },
  });

  const userID = localStorage.getItem("userID");

  const onSubmit = async (data) => {
    if (Object.keys(errors).length > 0) {
      console.log("Form has errors:", errors);
      return; // Prevent submission if there are errors
    }
    // console.log(dayjs(data.DOB).format("YYYY-MM-DD"));

    const formData = new FormData();

    formData.append("salutation", Encryptor.Encrypt(TrimFormData(data.salutation)));

    formData.append("nameInFull", Encryptor.Encrypt(TrimFormData(data.nameInFull)));

    formData.append("NRIC", Encryptor.Encrypt(TrimFormData(data.NRIC)));
    formData.append(
      "DOB",
      Encryptor.Encrypt(TrimFormData(dayjs(data.DOB).format("YYYY-MM-DD")))
    );

    const registeredAddressFields = [
      data.registeredAddressStreet,
      data.registeredAddressPostcode,
      data.registeredAddressCity,
      data.registeredAddressState,
    ];

    const formattedRegisteredAddress = registeredAddressFields
      .filter(Boolean)
      .join(", ");
    formData.append(
      "registeredAddress",
      Encryptor.Encrypt(TrimFormData(formattedRegisteredAddress))
    );
    formData.append(
      "registeredAddressState",
      Encryptor.Encrypt(TrimFormData(data.registeredAddressState))
    );

    const correspondenceAddressFields = [
      data.correspondenceAddressStreet,
      data.correspondenceAddressPostcode,
      data.correspondenceAddressCity,
      data.correspondenceAddressState,
    ];

    const formattedCorrespondenceAddress = correspondenceAddressFields
      .filter(Boolean)
      .join(", ");
    formData.append(
      "correspondenceAddress",
      Encryptor.Encrypt(TrimFormData(formattedCorrespondenceAddress))
    );
    formData.append(
      "correspondenceAddressState",
      Encryptor.Encrypt(TrimFormData(data.correspondenceAddressState))
    );

    formData.append(
      "placeOfEmployment",
      Encryptor.Encrypt(TrimFormData(data.placeOfEmployment))
    );
    formData.append("officeAddress", Encryptor.Encrypt(TrimFormData(data.officeAddress)));

    formData.append("officeTelNo", Encryptor.Encrypt(TrimFormData(data.officeTelNo)));
    formData.append("HPNo", Encryptor.Encrypt(TrimFormData(data.HPNo.replace("+", ""))));
    formData.append("email", Encryptor.Encrypt(TrimFormData(data.email)));
    formData.append("designation", Encryptor.Encrypt(TrimFormData(data.designation)));

    formData.append("natureOfWork", Encryptor.Encrypt(TrimFormData(data.natureOfWork)));
    formData.append(
      "noOfYearsWithPresentEmployer",
      Encryptor.Encrypt(TrimFormData(data.noOfYearsWithPresentEmployer))
    );
    formData.append(
      "previousEmploymentPeriod_1",
      Encryptor.Encrypt(TrimFormData(data.previousEmploymentPeriod_1))
    );
    formData.append(
      "previousEmploymentDesignation_1",
      Encryptor.Encrypt(TrimFormData(data.previousEmploymentDesignation_1))
    );
    formData.append(
      "previousEmploymentPeriod_2",
      Encryptor.Encrypt(TrimFormData(data.previousEmploymentPeriod_2))
    );
    formData.append(
      "previousEmploymentDesignation_2",
      Encryptor.Encrypt(TrimFormData(data.previousEmploymentDesignation_2))
    );
    formData.append(
      "academicQualification",
      Encryptor.Encrypt(TrimFormData(data.academicQualification))
    );
    formData.append(
      "otehracademicQualification",
      Encryptor.Encrypt(TrimFormData(data.otheracademicQualification))
    );
    formData.append(
      "tertiaryProfessional",
      Encryptor.Encrypt(TrimFormData(data.tertiaryProfessional))
    );
    formData.append(
      "IndividualMembershipCategory",
      Encryptor.Encrypt(TrimFormData(data.IndividualMembershipCategory))
    );
    formData.append("eInvoiceNumber", Encryptor.Encrypt(TrimFormData(data.eInvoiceNumber)));

    formData.append("userID", TrimFormData(userID));

    // console.log(data.salutation);
    try {
      const response =
        await ApplicationFormController.submitIndividualApplication(formData);
      console.log(response);
      if (response.status === "success") {
        reset();
        window.scrollTo({ top: 0, behavior: "smooth" });
        // openNotificationWithIcon(
        //   "success",
        //   "Application has been submitted!",
        //   "Success"
        // );

        SetPopupMessage("Your registration has been submitted successfully.");
        SetPopupAction(() => () => {
          SetPopupMessage("");
        });

        //membership registration success, send notification to secretariate mail here
        SendNewRegistrationNotificationToSecretariate(data);
      }
    } catch (error) {
      SetPopupMessage("Failed to submit your registration.\nPlease try again or contact PPK's support.");
      SetPopupAction(() => () => {
        SetPopupMessage("");
      });
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  const [api, contextHolder] = notification.useNotification();
  const openNotificationWithIcon = (type, desc, message) => {
    api[type]({
      message: message,
      description: desc,
    });
  };

  //edited by delon on 2025-05-30
  //render functions
  const RenderPopupMessageBox = () => {
    return (
      <Fragment>
        <div className="popup-ui-block" />
        <div className="popup-message-box">
          <span className="popup-message-lbl">{popupMessage}</span>
          <div className="option-panel">
            <button className="option-btn" onClick={() => popupAction()}>
              Done
            </button>
          </div>
        </div>
      </Fragment>
    );
  };

  //added by delon 2025-07-23 to do formdata checking and purging
  const TrimFormData = (data) => {
    //replace "'" character -> "`"
    let res = data.toString();
    res = data.toString().replace(/'/g, "`");
    return res;
  }

  //addeed by delon 2025-12-02
  const SendNewRegistrationNotificationToSecretariate = (data) => {
    const formData = new FormData();
    const dateNow = new Date();
    formData.append('s3cr3t', Encryptor2.Encrypt('ppkm_14082024_mobile'));
    formData.append('sendNewRegistrationNotification', Encryptor2.Encrypt('true'));
    formData.append('type', Encryptor2.Encrypt('INDIVIDUAL'));
    formData.append('name', Encryptor2.Encrypt(data.nameInFull));
    formData.append('datetime', Encryptor2.Encrypt(IonDateString(dateNow, IonDateFormat.MALAYSIA_STANDARD)));

    axios.post('https://www.ppkm.org.my/mobile_backend/scripts/mailControl.php', formData, { withCredentials: false }).then((res) => {
      const resData = res.data;

      if(JSON.stringify(resData).includes('_false')) {
        console.log('SendNewRegistrationNotificationToSecretariateErr ' + resData);
      } else {
        console.log('checkRes: ' + JSON.stringify(resData));
      }
    }).catch((err) => {
      console.log('SendNewRegistrationNotificationToSecretariateErr ' + err);
    });
  }

  return (
    <>
      {contextHolder}

      <form
        onSubmit={handleSubmit(onSubmit, onInvalid, { shouldFocusError: true })}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Category of Membership{required()}
              </Typography>
              <SelectInput
                type="select"
                {...register("IndividualMembershipCategory", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.IndividualMembershipCategory
                    ? errors.IndividualMembershipCategory.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }}>
              <Typography variant="h6" gutterBottom>
                Salutation{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("salutation", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.salutation ? errors.salutation.message : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 9 }}>
              <Typography variant="h6" gutterBottom>
                Name in Full{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("nameInFull", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.nameInFull ? errors.nameInFull.message : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                NRIC Number{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("NRIC", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.NRIC ? errors.NRIC.message : ""}
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Date of Birth
              </Typography>
              <BasicDatePicker
                {...register("DOB", {
                  // required: "This field is required",
                })}
                onErrorCheck={errors.DOB ? errors.DOB.message : ""}
                control={control}
                name="DOB"
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }} gutterBottom>
                Registered Address
              </Typography>
            </Grid>

            <Grid size={{ xs: 6, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Street Address{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("registeredAddressStreet", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.registeredAddressStreet
                    ? errors.registeredAddressStreet.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                Postcode{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("registeredAddressPostcode", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.registeredAddressPostcode
                    ? errors.registeredAddressPostcode.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                City{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("registeredAddressCity", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.registeredAddressCity
                    ? errors.registeredAddressCity.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                State{required()}
              </Typography>
              <SelectInput
                type="text"
                {...register("registeredAddressState", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.registeredAddressState
                    ? errors.registeredAddressState.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h7" sx={{ fontWeight: "bold" }} gutterBottom>
                Correspondence Address
              </Typography>
            </Grid>

            <Grid size={{ xs: 6, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Street Address{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("correspondenceAddressStreet", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.correspondenceAddressStreet
                    ? errors.correspondenceAddressStreet.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                Postcode{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("correspondenceAddressPostcode", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.correspondenceAddressPostcode
                    ? errors.correspondenceAddressPostcode.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                City{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("correspondenceAddressCity", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.correspondenceAddressCity
                    ? errors.correspondenceAddressCity.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 6, md: 4 }}>
              <Typography variant="h6" gutterBottom>
                State{required()}
              </Typography>
              <SelectInput
                type="text"
                {...register("correspondenceAddressState", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.correspondenceAddressState
                    ? errors.correspondenceAddressState.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Place Of Employment{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("placeOfEmployment", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.placeOfEmployment
                    ? errors.placeOfEmployment.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Office Address{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("officeAddress", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.officeAddress ? errors.officeAddress.message : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Office Tel. No
              </Typography>
              <LandLinePhoneFormatter
                name="officeTelNo"
                onErrorCheck={
                  errors.officeTelNo ? errors.officeTelNo.message : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Mobile{required()}
              </Typography>
              <Controller
                name="HPNo"
                control={control}
                rules={{ required: "This field is required" }}
                render={({ field }) => (
                  <MuiTelInput
                    {...field}
                    value={field.value}
                    onChange={field.onChange}
                    defaultCountry="MY"
                    sx={{
                      width: "100%",
                      "& .MuiOutlinedInput-root": {
                        fontSize: "16px",
                        borderRadius: "25px",
                        color: "black",
                        backgroundColor: "white",
                        "& fieldset": {
                          borderColor: "#ccc",
                        },
                        "&:hover fieldset": {
                          borderColor: "#999",
                        },
                        // "&.Mui-focused fieldset": {
                        //   borderColor: "transparent",
                        //   outline: "none",
                        // },
                      },
                    }}
                    error={Boolean(errors.HPNo)}
                    helperText={errors.HPNo ? errors.HPNo.message : ""}
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Email{required()}
              </Typography>
              <TextInput
                type="email"
                {...register("email", {
                  required: "This field is required",
                })}
                onErrorCheck={errors.email ? errors.email.message : ""}
                onEmailCheck={(error) => {
                  if (error?.type === "invalidFormat") {
                    setError("email", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "duplicate") {
                    setError("email", {
                      type: "manual",
                      message: error.message,
                    });
                  } else if (error?.type === "duplicateInForm") {
                    setError("email", {
                      type: "manual",
                      message: error.message,
                    });
                  } else {
                    clearErrors("email");
                  }
                }}
                control={control}
                getValues={getValues} // <-- Pass getValues here
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Designation
              </Typography>
              <TextInput
                type="text"
                {...register("designation", {
                  // required: "This field is required",
                })}
                onErrorCheck={
                  errors.designation ? errors.designation.message : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Nature of Work
              </Typography>
              <TextInput
                type="text"
                {...register("natureOfWork", {
                  // required: "This field is required",
                })}
                onErrorCheck={
                  errors.natureOfWork ? errors.natureOfWork.message : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 12 }}>
              <Typography variant="h6" gutterBottom>
                Number of Years With Present Employer{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("noOfYearsWithPresentEmployer", {
                    required: "This field is required",
                })}
                onErrorCheck={
                  errors.noOfYearsWithPresentEmployer
                    ? errors.noOfYearsWithPresentEmployer.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <Typography
                variant="h7"
                sx={{ fontWeight: "bold", marginTop: "50px" }}
                gutterBottom
              >
                Previous Employer(s)
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Period 1
              </Typography>
              <TextInput
                type="text"
                {...register("previousEmploymentPeriod_1", {
                  required: false,
                })}
                onErrorCheck={
                  errors.previousEmploymentPeriod_1
                    ? errors.previousEmploymentPeriod_1.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Designation
              </Typography>

              <TextInput
                type="text"
                {...register("previousEmploymentDesignation_1", {
                  required: false,
                })}
                onErrorCheck={
                  errors.previousEmploymentDesignation_1
                    ? errors.previousEmploymentDesignation_1.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Period 2
              </Typography>
              <TextInput
                type="text"
                {...register("previousEmploymentPeriod_2", {
                  required: false,
                })}
                onErrorCheck={
                  errors.previousEmploymentPeriod_2
                    ? errors.previousEmploymentPeriod_2.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Designation
              </Typography>

              <TextInput
                type="text"
                {...register("previousEmploymentDesignation_2", {
                  required: false,
                })}
                onErrorCheck={
                  errors.previousEmploymentDesignation_2
                    ? errors.previousEmploymentDesignation_2.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Academic Qualifications{required()}
              </Typography>
              <SelectInput
                type="select"
                {...register("academicQualification", {
                    required: "This field is required",
                })}
                onErrorCheck={
                  errors.academicQualification
                    ? errors.academicQualification.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Other Academic Qualification
              </Typography>
              <TextInput
                type="text"
                {...register("otheracademicQualification", {
                  // required: "This field is required",
                })}
                onErrorCheck={
                  errors.otheracademicQualification
                    ? errors.otheracademicQualification.message
                    : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Tertiary/Professional
              </Typography>
              <TextInput
                type="text"
                {...register("tertiaryProfessional", {
                  // required: "This field is required",
                })}
                onErrorCheck={
                  errors.tertiaryProfessional
                    ? errors.tertiaryProfessional.message
                    : ""
                }
                control={control}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="h6" gutterBottom>
                Individual TIN No.{required()}
              </Typography>
              <TextInput
                type="text"
                {...register("eInvoiceNumber", {
                  required: "This field is required",
                })}
                onErrorCheck={
                  errors.eInvoiceNumber ? errors.eInvoiceNumber.message : ""
                }
                control={control}
              />
            </Grid>

            <Grid size={{ xs: 12, md: 12 }}>
              <span>
                <b>PERSONAL DATA PROTECTION ACT (PDPA) CONSENT FORM</b>
              </span>
              <br />
              <p
                style={{
                  textAlign: "justify",
                  marginTop: "5px",
                  marginBottom: 0,
                }}
              >
                At PPK Malaysia, we respect the privacy of individuals and the
                use of their personal data according to the PDPA. Personal data
                could be your name, contact details and any other data which we
                may obtain from you for the purpose of processing your
                membership application with our organization. Please rest
                assured that we will take reasonable care and precaution to
                prevent the loss or misuse of your Personal Information. The
                processing of your Personal Information is also subject to
                applicable laws. The Personal Information which you provide to
                us now or from time to time or have provided to us previously
                will be used and processed, and continued to be used and
                processed by us, in accordance with this Privacy Policy (as
                amended, varied or revised from time to time). By submitting the
                said information to us herein, we trust you have no objections
                to the processing of your personal data by our organization in
                accordance with the PDPA. Thank you.
              </p>
            </Grid>
          </Grid>

          <Box sx={{ marginTop: 5, display: 'flex', justifyContent: 'center' }}>
            {/* <HCaptcha
              sitekey="268ee364-a8e6-44aa-a1b2-e906701ec176"
              onVerify={(token,ekey) => {SetHCaptchaToken(token);}}
            /> ---deprecated of unuse*/}
            <ICaptcha captchaVerification={captchaVerification} SetCaptchaVerification={SetCaptchaVerification} codeLength={4} />
          </Box>

          <Grid
            container
            size={{ xs: 12, md: 12 }}
            sx={{ paddingBottom: "90px" }}
          >
            <Button
              sx={{
                position: "fixed", // Keep the button fixed on scroll
                bottom: "16px", // Distance from the bottom of the screen
                left: "0", // Position from the left edge of the screen
                right: "0", // Position from the right edge to keep it full width
                zIndex: 1000, // Ensure it's above other content
                borderRadius: "20px",
                mt: 4,
                mb: 4,
                width: "100%", // Set initial width as a percentage
                maxWidth: "1150px", // Set a maximum width to avoid the button getting too large
                minWidth: "200px", // Set a minimum width to avoid the button getting too small
                height: "48px",
                backgroundColor: "#d33333",
                margin: "0 auto", // Center the button horizontally
              }}
              variant="contained"
              type="submit"
              disabled={!captchaVerification}
            >
              <Typography variant="h6">Save</Typography>
            </Button>
          </Grid>
        </Box>
      </form>

      {popupMessage.length > 0 ? RenderPopupMessageBox() : null}
    </>
  );
};

export default Register;
